define("auth/controllers/signup/index", ["exports", "@ember/controller"], function (_exports, _controller) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/controller"eaimeta@70e063a35619d71f
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  class SignupController extends _controller.default {
    constructor() {
      super(...arguments);
      // Note: utm params are not all explicitly used here, but are used in sessions service handleNewAccount
      _defineProperty(this, "queryParams", ['utm_source', 'utm_campaign', 'utm_medium']);
      _defineProperty(this, "utm_source", undefined);
    }
    get utmSource() {
      return this.utm_source;
    }
  }
  _exports.default = SignupController;
});